import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StripePaymentMethodModel } from '../../../../../../../common/dist/angular/models/stripe-payment-method.model';

@Component({
  selector: 'app-license-suspended-modal',
  templateUrl: './delete-payment-method-modal.component.html',
  styleUrls: ['./delete-payment-method-modal.component.scss'],
  standalone: false,
})
export class DeletePaymentMethodModalComponent {

  public paymentMethod: StripePaymentMethodModel;

  constructor(public activeModal: NgbActiveModal) {
  }
}
